import { Flexbox } from "@components/styles/mixins/Flexbox.styled";
import styled from "styled-components";

export const Nav = styled.nav`
    background-color: ${({ theme }) => theme.colors.emerald30};
    height: ${({ theme }) => theme.height.navbarHeight};
    ${Flexbox({
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
    })}
    padding:1rem 8rem;
    .img-container{
        ${Flexbox({justifyContent:"flex-start", alignItems:"center", flexDirection:"row"})}
        ${Flexbox({justifyContent:"flex-start", alignItems:"center", flexDirection:"row"})}
    }
    @media all and (max-width: ${({ theme }) => theme.breakpoints.breakpoint0}) {
        padding:1rem 3rem;
    }
    @media all and (max-width: ${({ theme }) => theme.breakpoints.breakpoint1}) {
        padding:1.2rem;
    }
    img{
        cursor:pointer;
        justify-self:flex-start;
        width:5rem;
    }
`;
